import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useLocation } from 'react-router-dom';
import { Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import NonIndexableHelmet from '../components/NonIndexableHelmet';
import { getTokenMeta } from '../data/nonIndexableMeta';

const ResolveTokenPage = () => {
  const { groupId, token: tokenParam } = useParams();
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const [status, setStatus] = useState('loading'); // loading, redirecting, error
  const [errorMessage, setErrorMessage] = useState('');

  const tokenMetaPath = pathname.includes('/resolve-token') ? '/resolve-token' : '/group';
  const helmet = <NonIndexableHelmet {...getTokenMeta(tokenMetaPath)} />;

  useEffect(() => {
    const redirectWithToken = (tokenToUse, gpsParams = {}) => {
      const apiUrl = process.env.REACT_APP_API_URL || '/api';
      let resolveUrl = `${apiUrl}/galene/resolve-token/${tokenToUse}`;
      const params = new URLSearchParams(gpsParams);
      if (params.toString()) {
        resolveUrl += `?${params.toString()}`;
      }
      setStatus('redirecting');
      window.location.href = resolveUrl;
    };

    const resolveToken = () => {
      const token = tokenParam || searchParams.get('token');

      if (!token) {
        setStatus('error');
        setErrorMessage('Token manquant dans l\'URL');
        return;
      }

      if (!tokenParam && !groupId) {
        setStatus('error');
        setErrorMessage('ID de groupe manquant dans l\'URL');
        return;
      }

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude, accuracy } = position.coords;
            redirectWithToken(token, {
              lat: latitude.toString(),
              lng: longitude.toString(),
              ...(accuracy && !isNaN(accuracy) ? { accuracy: accuracy.toString() } : {}),
            });
          },
          () => {
            redirectWithToken(token);
          },
          { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
        );
      } else {
        redirectWithToken(token);
      }
    };

    resolveToken();
  }, [groupId, tokenParam, searchParams]);

  if (status === 'loading' || status === 'redirecting') {
    return (
      <>
        {helmet}
        <div className="auth-page-gradient auth-page-shell">
          <div className="text-center text-white">
            <Spinner animation="border" variant="light" style={{ width: '3rem', height: '3rem' }} />
            <p className="mt-3">
              {status === 'loading' ? 'Vérification du token...' : 'Redirection vers la session...'}
            </p>
          </div>
        </div>
      </>
    );
  }

  if (status === 'error') {
    return (
      <>
        {helmet}
        <div className="auth-page-gradient auth-page-shell">
          <Container>
            <Row className="justify-content-center">
              <Col md={6}>
                <Card className="shadow-lg border-0">
                  <Card.Body className="p-5 text-center">
                    <div style={{ fontSize: '4rem', color: '#dc3545' }}>
                      <i className="bi bi-exclamation-circle-fill"></i>
                    </div>
                    <h3 className="mt-3 fw-bold">Erreur de connexion</h3>
                    <Alert variant="danger" className="mt-3">
                      {errorMessage}
                    </Alert>
                    <p className="text-muted mt-3">
                      Ce lien de dépannage n'est pas valide ou a expiré.
                      Veuillez contacter votre technicien pour obtenir un nouveau lien.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }

  return helmet;
};

export default ResolveTokenPage;
